import { render, staticRenderFns } from "./with-loader.vue?vue&type=template&id=f51407d2&"
import script from "./with-loader.vue?vue&type=script&lang=ts&"
export * from "./with-loader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports